var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconEdit = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.5 16.5",
    style: {
      enableBackground: "new 0 0 17.5 16.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264D6D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,13.9l9.9-9.7l0,0C17,3.8,17.2,3.4,17.2,3c0-0.4-0.2-0.9-0.5-1.2l-1.3-1.3c-0.6-0.6-1.7-0.6-2.4,0 l-9.9,9.8l0,0l-0.4,4L6.8,13.9L6.8,13.9z M4.4,12.6l0.2-1.6l7.7-7.5l1.5,1.4l-7.7,7.5L4.4,12.6z M15.6,3C15.6,3,15.6,3,15.6,3 l-0.8,0.8l-1.5-1.4L14,1.6h0.1l0,0l0,0h0.1L15.6,3L15.6,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,14.9H0.8c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h15.8c0.4,0,0.8-0.3,0.8-0.8S17,14.9,16.6,14.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_edit.97c1ea04.svg";
export { ForwardRef as ReactComponent };